<div class="footer">
  <div class="g-container">
    <div class="footer-content">
      <div class="footer-block contacts">

        <ul class="contacts-phones">
          @for (phoneNumber of MANAGER_PHONES; track phoneNumber) {
            <li class="contacts-phone-container">
              <a
                class="contacts-phone g-main-link"
                [href]="'tel:' + phoneNumber"
              >
                {{ phoneNumber | mask:PHONE_NUMBER_MASK }}
              </a>
            </li>
          }
        </ul>

        <div class="contacts-work-hours">{{ 'footer.fr-st' | translate }} 9:00-18:00</div>

        <a class="contacts-email g-main-link" [href]="'mailto:info@' + WEBSITE_HOSTNAME">info&#64;{{ WEBSITE_HOSTNAME }}</a>
        <a class="contacts-email g-main-link" href="https://www.instagram.com/klondike.com.ua">instagram.com/klondike.com.ua</a>
        <a class="contacts-email g-main-link" href="https://www.facebook.com/klondike.com.ua">facebook.com/klondike.com.ua</a>
        <span class="contacts-fop-details">ФОП Малікова Олена Іванівна<br>ЄДРПОУ 2405506444</span>
      </div>

      <div class="footer-block menu">
        <service-menu
          [isInFooter]="true"
          layout="vertical"
        />

        <div class="menu-badge">
          <div #badgeRef></div>
        </div>
      </div>

      <lang-selector class="footer-block lang" />

      <div class="footer-block methods">
        <img
          class="methods-item"
          src="/assets/images/mastercard.jpg"
          alt="Mastercard"
          loading="lazy"
        >
        <img
          class="methods-item"
          src="/assets/images/visa.jpg"
          alt="Visa"
          loading="lazy"
        >
      </div>
    </div>
  </div>
</div>
